import { Helmet } from 'react-helmet-async';

interface Props {
    title?: string;
}

export const Title = ({ title }: Props) => (
    <Helmet>
        <title>{`${title || ''} - LSoft Technologies`}</title>
    </Helmet>
);
